export const SANDSTONE = "#F4CC70";
export const BURNT_ORANGE = "#DE7A22";
export const SEA = "#20948B";
export const LAGOON = "6AB187";